import React from "react";
import HistoryTabView from "./components/history-tab-view/HistoryTabView";

export default function HistoryTab({ informationId = 0, isRequirement = false }) {
	return <HistoryTabView informationId={informationId} isRequirement={isRequirement} />;
}
